// Post.tsx
import "./Post.css"
import { useParams } from "react-router-dom"
import Categories from "@/commons/objects/category/Categories"
import React, { useEffect, useRef, useState } from "react"
import ApiInterface from "@/commons/api/ApiInterface"
import Cookies from "js-cookie"
import { environment } from "@/commons/configs/Config"
import { useInfoBox } from "@/commons/infoBox/InfoBox"
import Redirector from "@/commons/utils/Redirects"
import Redirects from "@/commons/utils/Redirects"
import { isStaffer } from "@/commons/api/apiPages/Details"
import { decoded } from "@/commons/base64/Decoder"
import BaseInfoBoxs from "@/commons/infoBox/BaseInfoBoxs"
import {checkText, getResponseText} from "@/commons/tickets/TicketsCommons"
import Background from "@/commons/pages/borders/background/Background"
import Header from "@/commons/pages/borders/header/Header"
import Footer from "@/commons/pages/borders/footer/Footer"
import ReactDOM from "react-dom"
import ZoomImageModal from "@/reports/pages/post/ZoomImageModal"

import Comment from "./objects/Comment"
import reportUpdateSound from "@/commons/resources/sounds/reportUpdateSound.mp3"
import reportChangedSound from "@/commons/resources/sounds/reportChangedSound.mp3"

import { connectWebSocket, disconnectWebSocket } from "@/commons/websocket/websocketClient";

// IMPORT del nuovo Editor
import Editor from "@/reports/editor/Editor"

const SinglePost = () => {
    const { addInfo, addPersistentInfo, updatePersistentInfo, removePersistentInfo } = useInfoBox()
    let [postJSON, setPostJSON] = useState(null)
    let { id } = useParams()
    let categoryId = 0
    let itemsPerPage = 20

    const [commentComponents, setCommentComponents] = useState([])
    const [liveStatus, setLiveStatus] = useState("")
    const [liveCategory, setLiveCategory] = useState("")
    const [maxPage, setMaxPage] = useState(1);
    const [page, setPage] = useState(0);
    const pageRef = useRef(0);
    const maxPageRef = useRef(1);



    // Riferimento al nuovo Editor (per fare .getHTML())
    const editorRef = useRef(null)
    const [value, setValue] = useState("")

    // Prima definivi modules = {...} e handleDropDescription -> le abbiamo spostate in Editor.tsx.

    async function getTotalItems() {
        const total = await fetchTotalComments()
        let p = Math.ceil(total / itemsPerPage)
        if (p === 0) p = 1
        setMaxPage(p)
    }

    const playUpdateSound = (sound) => {
        const audio = new Audio(sound)
        audio.currentTime = 0 // restart se sta già suonando
        audio.play().catch((e) => {
            console.warn("Non riesco a riprodurre il suono:", e)
        })
    }

    async function loadPostInfo() {
        const userToken = Cookies.get(environment.tokenName)
        if (userToken === undefined) return
        const result = fetch(environment.apiUrlOne + "/posts/getPost/" + id, {
            method: "GET",
            headers: {
                Authorization: userToken
            }
        })

        const rest = await result
        return rest
    }

    async function fetchTotalComments() {
        const userToken = Cookies.get(environment.tokenName)
        if (!userToken) return 0

        const pageData = { page: 0, items: 1 }
        const response = await fetch(environment.apiUrlOne + "/comment/getComments/" + id, {
            method: "POST",
            headers: {
                Authorization: userToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })

        if (response.status !== 200) return 0

        const json = await response.json()
        return json.totalElements || 0
    }
    const appendComment = (commentJson) => {
        const key = `comment_${commentJson.id}`
        const alreadyExists = commentComponents.some(comp => comp.key === key)
        if (alreadyExists) return

        const newComment = (
            <Comment
                key={`comment_${commentJson.id}`}
                commentJson={commentJson}
                onClickUsername={(userId, event) => redirectToProfile(userId, event)}
            />
        )

        setCommentComponents(prev => [...prev, newComment])
    }
    async function loadComments() {
        setCommentComponents([])
        const userToken = Cookies.get(environment.tokenName)
        let pageData = { page: page, items: itemsPerPage }
        if (!userToken) return

        const response = await fetch(environment.apiUrlOne + "/comment/getComments/" + id, {
            method: "POST",
            headers: {
                Authorization: userToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })

        if (response.status !== 200) return

        const jsonC = await response.json()
        const comments = jsonC["content"]
        let lastCommentId = ""

        comments.map((comment) => {
            lastCommentId = `comment_${comment.id}`
            appendComment(comment)
        })

        // scrolla all’ultimo commento dopo il render
        setTimeout(() => {
            const last = document.getElementById(lastCommentId)
            if (last) last.scrollIntoView({ block: "center" })
        }, 0)
    }

    async function baseToText(base64) {
        let html
        try {
            html = decoded(base64)
        } catch (e) {
            html = base64
        }
        return html
    }

    async function redirectToProfile(id, event) {
        let isStaff = await isStaffer()
        if (isStaff) {
            Redirects.domainSendClick("admin", "user/" + id, event)
        }
    }

    function openBigImage(imageSrc) {
        if (!imageSrc) return
        const container = document.createElement("div")
        document.body.appendChild(container)

        const handleClose = () => {
            ReactDOM.unmountComponentAtNode(container)
            container.remove()
        }

        ReactDOM.render(
            <ZoomImageModal imageSrc={imageSrc} onClose={handleClose} />,
            container
        )
    }

    function clickableImages(element) {
        const imgTags = element.getElementsByTagName("img")
        for (let i = 0; i < imgTags.length; i++) {
            const img = imgTags[i]
            img.onclick = () => {
                openBigImage(img.getAttribute("src"))
            }
        }
    }

    async function loadElementImage(elementID) {
        let element = document.getElementById(elementID)
        if (!element) return
        let html = element.innerHTML

        html = await getImage(html)
        element.innerHTML = html

        clickableImages(element)
    }

    async function loadAll() {
        const jsonText = postJSON
        if (!jsonText) return

        let postTitle = document.getElementById("postTitle")
        let postBody = document.getElementById("postBody")
        let postAuthor = document.getElementById("postAuthor")
        let postDate = document.getElementById("postDate")

        categoryId = jsonText["categoryId"].id

        let postTitleText = jsonText["title"]
        let status = jsonText["status"]
        let category = jsonText["categoryId"]
        let user = jsonText["userId"]
        let postBodyText = jsonText["content"]
        let postDateText = jsonText["time"]

        let notTime = new Date(postDateText)
        let notTimeFormatted = notTime.toLocaleDateString()

        let roleImage = await ApiInterface.loadRoleImage(user.staffGroup.id)
        const imageSrc = roleImage

        setLiveStatus(status)
        setLiveCategory(category.name)

        if (postTitle) postTitle.innerHTML = postTitleText
        if (postAuthor) {
            postAuthor.innerHTML =
                "Autore: " +
                user.username +
                "  <img src='" +
                imageSrc +
                "' alt=\"" +
                user.staffGroup.groupName +
                '" />'
            postAuthor.addEventListener("click", event => {
                redirectToProfile(user.id, event)
            })
            postAuthor.classList.add("clickable")
        }
        if (postBody) {
            postBody.innerHTML = await baseToText(postBodyText)
            loadElementImage("postBody")
        }
        if (postDate) postDate.innerHTML = notTimeFormatted
    }

    async function loadButtons() {
        let closeOpenButton = document.getElementById("changeReportStatus")
        if (!closeOpenButton) return
        let buttonReply = document.getElementById("responseButton")
        if (!buttonReply) return

        closeOpenButton.disabled = false
        buttonReply.disabled = false
        await updateButtons()
    }

    useEffect(() => {
        updateButtons();
    }, [value]);

    useEffect(() => {
        maxPageRef.current = maxPage;

        changePage(maxPage - 1)
    }, [maxPage]);

    async function updateButtons() {
        let closeOpenButton = document.getElementById("changeReportStatus")
        if (!closeOpenButton) return
        let buttonReply = document.getElementById("responseButton")
        if (!buttonReply) return

        const editorContent = value || "";
        let text = await checkText(editorContent)
        if (text === null || text === "empty") {
            text = ""
        }
        if (text === "") {
            if (liveStatus.toLowerCase() === "open") {
                closeOpenButton.innerHTML = "Chiudi Report"
                closeOpenButton.onclick = () => {
                    closeOpenButton.disabled = true
                    buttonReply.disabled = true
                    closeReport()
                }
            } else {
                closeOpenButton.innerHTML = "Riapri Report"
                closeOpenButton.onclick = () => {
                    closeOpenButton.disabled = true
                    buttonReply.disabled = true
                    openReport()
                }
            }
        } else {
            if (liveStatus.toLowerCase() === "open") {
                closeOpenButton.innerHTML = "Rispondi e chiudi"
                closeOpenButton.onclick = () => {
                    closeOpenButton.disabled = true
                    buttonReply.disabled = true
                    addResponse().then(() => {
                        closeReport()
                    })
                }
            } else {
                closeOpenButton.innerHTML = "Riapri rispondendo"
                closeOpenButton.onclick = () => {
                    closeOpenButton.disabled = true
                    buttonReply.disabled = true
                    addResponse()
                }
            }
        }

        buttonReply.innerHTML = "Rispondi"
        if (text === "") {
            buttonReply.disabled = true
        } else {
            if (liveStatus.toLowerCase() === "open") {
                buttonReply.disabled = false
            } else {
                buttonReply.disabled = true
            }
        }
        buttonReply.onclick = () => {
            closeOpenButton.disabled = true
            buttonReply.disabled = true
            addResponse()
        }
    }

    function changePage(value) {
        setPage(value)
    }

    useEffect(() => {
        pageRef.current = page;

        setCommentComponents([]) // reset commenti visivi
        getTotalItems();
        loadComments()
    }, [page]);

    useEffect(() => {
        loadAll()
    }, [postJSON]);

    function switchCategory() {
        let selector = document.getElementById("categorySelectionAdmin")
        let categoryId = selector.options[selector.selectedIndex].value
        ApiInterface.editCategory(
            id,
            categoryId,
            "Categoria aggiornata<br/> %old% -> %new%"
        )
            .then(r => {
                if (r.status === 200) {
                    addInfo(
                        "success",
                        "categoria cambiata",
                        "la categoria è stata cambiata con successo.",
                        5
                    )
                } else {
                    addInfo(
                        "alert",
                        "Errore",
                        "C'è stato un errore durante il cambio della categoria."
                    )
                }
            })
            .catch(e => {
                addInfo(
                    "alert",
                    "Errore",
                    "C'è stato un errore durante il cambio della categoria."
                )
            })
    }

    async function loadAdminZone() {
        let adminZone = document.getElementById("post_adminButtons")
        if (!adminZone) return
        adminZone.innerHTML = ""
        let isStaff = await ApiInterface.isStaffer()
        if (!isStaff) {
            return
        }

        let categoryName = document.createElement("span")
        categoryName.setAttribute("id", "categoryName")
        categoryName.innerHTML = "Modifica categoria: "
        adminZone.appendChild(categoryName)

        let categorySelection = document.createElement("select")
        categorySelection.setAttribute("id", "categorySelectionAdmin")
        categorySelection.innerHTML = ""

        let option = document.createElement("option")
        option.setAttribute("value", "0")
        option.innerText = "Seleziona una categoria"
        option.disabled = true
        option.selected = true
        categorySelection.appendChild(option)

        let cats = await ApiInterface.getCategories()
        if (cats.status !== 200) {
            return
        }

        let json = await cats.json()
        let allCats = new Categories()
        allCats.addAllCat(json)

        for (const cat of allCats.categories) {
            const option = document.createElement("option")
            option.setAttribute("value", cat.id)
            if (cat.id === categoryId) {
                option.selected = true
            }
            option.innerText = cat.name

            if (cat.orderId <= -1) {
                continue
            }
            switch (cat.usable.toLowerCase()) {
                case "separator":
                    option.disabled = true
                    break
                default:
                    break
            }
            categorySelection.appendChild(option)
        }
        categorySelection.addEventListener("change", switchCategory)
        adminZone.appendChild(categorySelection)
    }

    async function loadPostJson() {
        const postInfo = await loadPostInfo()
        if (postInfo?.status !== 200) {
            Redirector.send("/", null, { popupData: BaseInfoBoxs("noReportFound") })
        } else {
            let json = await postInfo.json()
            setPostJSON(json)
        }
    }

    useEffect(() => {
        loadPostJson();

        function handleMessage(data) {
            const realPage = pageRef.current + 1;
            const realMaxPage = maxPageRef.current;
            if (data.status === "OPENED") {
                setLiveStatus("open");
                if (page !== realMaxPage) {
                    window.addInfo("warning", "Report riaperto", "Il report è appena stato riaperto!", 6)
                }
                playUpdateSound(reportChangedSound)
            } else if (data.status === "CLOSED") {
                playUpdateSound(reportChangedSound)
                setLiveStatus("closed");
                if (realPage !== realMaxPage) {
                    window.addInfo("alert", "Report chiuso", "Il report è appena stato chiuso!", 6)
                }
                playUpdateSound(reportChangedSound)
            } else if (data.comment) {
                if(data.comment.userId.username !== "SISTEMA"){
                    playUpdateSound(reportUpdateSound)
                }
                if (realPage === realMaxPage) {
                    appendComment(data.comment)
                    setTimeout(() => {
                        const el = document.getElementById(`comment_${data.comment.id}`)
                        if (el) el.scrollIntoView({ block: "center", behavior: "smooth" })
                    }, 100)
                } else {
                    if(data.comment.userId.username !== "SISTEMA") {
                        window.addInfo("info", "Nuova risposta", "È arrivata una nuova risposta al report!", 6)
                    }
                }
            } else if (data.category) {
                playUpdateSound(reportUpdateSound)
                setLiveCategory(data.category.name)
                if (realPage !== realMaxPage) {
                    window.addInfo("info", "Categoria aggiornata", "La categoria del report è stata aggiornata!", 6)
                }
            }
        }

        if (id) connectWebSocket(id, handleMessage);
        return () => disconnectWebSocket();
    }, []);

    useEffect(() => {
        loadButtons()
    }, [liveStatus])

    function isImage(UUID) {
        if (UUID.startsWith("http")) return true
        if (UUID.startsWith("data:image")) return true
        return false
    }

    async function getImage(text) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(text, "text/html")
        const imgTags = doc.getElementsByTagName("img")

        for (let i = 0; i < imgTags.length; i++) {
            const img = imgTags[i]
            const UUID = img.getAttribute("src")
            if (!UUID) continue
            if (isImage(UUID)) continue

            if (UUID.includes("data:image")) continue

            const result = await ApiInterface.getImage(UUID)
            if (result.status !== 200) {
                if (result.status === 404) {
                    const result2 = await ApiInterface.getFileUrl(UUID)
                    if (result2 === null) {
                        img.setAttribute("src", UUID)
                    } else {
                        img.setAttribute("src", result2)
                    }
                } else {
                    img.setAttribute("src", UUID)
                }
            } else {
                let json = await result.json()
                img.setAttribute("src", json.value)
            }
        }
        return doc.documentElement.innerHTML
    }

    async function addResponse() {
        let button = document.getElementById("responseButton")
        button.disabled = true
        button.innerHTML = "Pubblico la risposta..."
        button.classList.add("button--loading")

        // Ora prendiamo l’HTML direttamente dal nostro Editor
        window.addPersistentInfo("info", "Invio risposta", "Stiamo inviando la tua risposta!");
        const editorContent = value || "";
        let text = await getResponseText(editorContent, { addInfo, addPersistentInfo, updatePersistentInfo, removePersistentInfo })
        if (text == null) {
            button.innerHTML = "Errore"
            button.classList.remove("button--loading")
            window.updatePersistentInfo({type: "alert", title: "Errore", text: "C'è stato un errore imprevisto", destroyIn: 10});
            return
        }
        if (text === "empty") {
            button.innerHTML = "Errore"
            button.classList.remove("button--loading")
            window.updatePersistentInfo({type: "alert", title: "Dati mancanti", text: "Il commento non può essere vuoto!", destroyIn: 10});
            return
        }
        let opened
        if (liveStatus.toLowerCase() === "open") {
            opened = true
        } else {
            opened = await openSilently()
        }
        if (opened === true) {
            let response = await ApiInterface.addComment(text, id)
            if (response.status === 200) {
                // Svuota l'Editor
                setValue("")
                button.disabled = false
                button.innerHTML = "Rispondi"
                button.classList.remove("button--loading")
                window.updatePersistentInfo({type: "success", title: "Risposta inviata", text:  "Risposta inviata correttamente", destroyIn: 3})
                return
            } else if (response.status === 418) {
                let json = await response.json()
                if (json) {
                    window.updatePersistentInfo({type: json["object"]["type"], title: json["object"]["title"], text:  json["object"]["text"], destroyIn: 7})
                }
                button.disabled = true
                button.innerHTML = "Sei bannatə"
                button.classList.remove("button--loading")
                return
            } else {
                window.updatePersistentInfo({type: "alert", title: "Errore", text:  "Si è verificato un errore durante l'aggiunta del commento.", destroyIn: 7})
                button.disabled = false
                button.innerHTML = "Rispondi"
                button.classList.remove("button--loading")
                return
            }
        }
    }

    async function closeReport() {
        const text = "<span style='color: #b70000'>Report chiuso da %user%</span>"
        let response = await ApiInterface.closeReport(id, text)
        if (response.status === 418) {
            let json = await response.json()
            if (json) {
                addInfo(
                    json["object"]["type"],
                    json["object"]["title"],
                    json["object"]["text"],
                    7
                )
                return
            }
        } else if (response.status !== 200) {
            addInfo(
                "alert",
                "Errore",
                "Si è verificato un errore durante la chiusura del report."
            )
        }
    }

    async function openReport() {
        const text = "<span style='color: #52ea00'>Report riaperto da %user%</span>"
        let response = await ApiInterface.openReport(id, text)
        if (response.status === 418) {
            let json = await response.json()
            if (json) {
                addInfo(
                    json["object"]["type"],
                    json["object"]["title"],
                    json["object"]["text"],
                    7
                )
            }
        } else if (response.status !== 200) {
            addInfo(
                "alert",
                "Errore",
                "Si è verificato un errore durante l'apertura del report."
            )
        }
    }

    async function openSilently() {
        const text =
            "<span style='color: #52ea00'>Report riaperto automaticamente</span>"
        let status = await ApiInterface.openReport(id, text).then(response => {
            return response.status === 200
        })
        return status
    }

    if (postJSON === null) {
        return <></>
    } else {
        return (
            <>
                <meta name="description" content={"EBLCraft report #" + id} />
                <Background />
                <div className={"page__body"}>
                    <Header/>
                    <div className={"page__content"} id={"page__content"}>
                        <div>
                            <div className={"Post_ReportsMainBox"}>
                                <br />
                                <div>
                                    <div className={"PostInfo"}>
                                        <div id={"postTitle"} className={"postTitle"}></div>
                                        <div id={"postDate"} className={"postDate"}></div>
                                        <div id="postStatus" className="postStatus">
                                            {liveStatus === "open" && <span style={{ color: "green" }}>Aperto</span>}
                                            {liveStatus === "closed" && <span style={{ color: "red" }}>Chiuso</span>}
                                        </div>
                                        <div id="postCategory" className="postCategory">
                                            {liveCategory && `Categoria: ${liveCategory}`}
                                        </div>
                                        <div id={"postAuthor"} className={"postAuthor"}></div>
                                        <div id={"postBody"} className={"postBody"}></div>
                                    </div>
                                    <div className={"PostComments"} id={"commentsList"}>
                                        {commentComponents}
                                    </div>
                                    <br />
                                    <b>Rispondi:</b>
                                    <br />
                                    <br />
                                    <Editor value={value} onChange={setValue}/>
                                    <div
                                        id={"post_adminButtons"}
                                        className={"post_adminButtons"}
                                    ></div>
                                    <div className={"post_buttons"}>
                                        <button
                                            className={"postResponse"}
                                            id={"responseButton"}
                                        ></button>
                                        <button id={"changeReportStatus"}></button>
                                    </div>
                                    <div className={"pageSelection"}>
                                        {page > 0 && (
                                            <>
                                                <span className="page-item" onClick={() => changePage(0)}>&lt;&lt;</span>
                                                <span className="page-item" onClick={() => changePage(page - 1)}>&lt;</span>
                                            </>
                                        )}
                                        {[...Array(7)].map((_, i) => {
                                            const newPage = page - 3 + i;
                                            if (newPage >= 0 && newPage < maxPage) {
                                                const isActive = newPage === page;
                                                return (
                                                    <span
                                                        key={newPage}
                                                        className={`page-item ${isActive ? "page-item-active" : ""}`}
                                                        onClick={isActive ? undefined : () => changePage(newPage)}
                                                        style={isActive ? { cursor: "default", pointerEvents: "none" } : {}}
                                                    >
                                                        {newPage + 1}
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })}
                                        {page < maxPage - 1 && (
                                            <>
                                                <span className="page-item" onClick={() => changePage(page + 1)}>&gt;</span>
                                                <span className="page-item" onClick={() => changePage(maxPage - 1)}>&gt;&gt;</span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </>
        )
    }
}

export default SinglePost
